import React, { useState, useImperativeHandle, forwardRef, useRef } from 'react';

export const NeuroaLogo = forwardRef(({ className }, ref) => {
    const [isHovering, setIsHovering] = useState(false);
    const [isClickBlinking, setIsClickBlinking] = useState(false);
    const blinkTimeoutRef = useRef(null);

    React.useEffect(() => {
        return () => {
            if (blinkTimeoutRef.current) {
                clearTimeout(blinkTimeoutRef.current);
            }
        };
    }, []);

    useImperativeHandle(ref, () => ({
        setHover: (hovering) => {
            setIsHovering(hovering);
        },
        wink: () => {
            if (blinkTimeoutRef.current) clearTimeout(blinkTimeoutRef.current);
            setIsClickBlinking(true);
            blinkTimeoutRef.current = setTimeout(() => {
                setIsClickBlinking(false);
                blinkTimeoutRef.current = null;
            }, 400);
        }
    }));

    const isActive = isHovering || isClickBlinking;

    return (
        <svg 
            viewBox="0 0 136 136" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect 
                x="59" y="60" width="59" height="58" rx="29" fill="black"
                style={{
                    opacity: isActive ? 0 : 1,
                    transform: isActive ? 'scale(0.8)' : 'scale(1)',
                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                    transformOrigin: 'center'
                }}
            />
            <path
                d="M 69 82 A 20 20 0 0 0 108 82"
                stroke="black"
                strokeWidth="16"
                strokeLinecap="round"
                style={{
                    opacity: isActive ? 1 : 0,
                    transform: isActive ? 'scale(1)' : 'scale(0.5)',
                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                    transformOrigin: 'center'
                }}
            />
            <rect 
                x="12" y="15" width="27" height="27" rx="13.5" fill="black"
                style={{
                    transform: isActive ? 'scaleY(0.35)' : 'scaleY(1)',
                    transition: 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                    transformOrigin: 'center'
                }}
            />
        </svg>
    );
});

NeuroaLogo.displayName = 'NeuroaLogo';
